
/**
 * Cache to register feature access lists for the current user
 * @kind cache
 * @class FeatureAccessListLookup
 * @description Custom lookup cache for FeatureAccessLists
 * @usage let lookup = await Grape.cache.get('FeatureAccessListLookup');
 */
export default {
	name: 'FeatureAccessListLookup',
	options: {
		table: 'v_feature_access_list',
		schema: 'savanna'
	}
};
